// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "productpg/" + {"189":"page-mixAndMatch","404":"page-singleProduct","406":"deferred"}[chunkId] + "." + {"189":"b7c053ff4bc2ee37da81","404":"c9bb409c5d3da2f612e6","406":"df2496841d8c49e8be92"}[chunkId] + ".css";
};